export default function LoadingScreen({ label = "載入中…" }: { label?: string }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream">
      <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      <div className="mt-4 text-muted text-sm">{label}</div>
    </div>
  );
}
